import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { AssessmentReviewDetailRouter } from '../components/Review';
import { update as updateUserGroupAssessment } from 'js/actions/user-group-assessment-actions';
import { useNotify } from 'js/hooks/useNotify';

function CapabilitiesAssessmentReviewDetailEngine({
  userGroup,
  userGroupAssessment,
  assessment,
  updateUserGroupAssessment,
}) {
  const notify = useNotify();

  const userGroupId = userGroup?.id;
  const userGroupAssessmentId = userGroupAssessment?.id;

  const handleArchive = useCallback(() => {
    updateUserGroupAssessment(userGroupId, userGroupAssessmentId, {
      archived_state: 'archived',
    })
      .then(() => {
        notify({
          type: 'success',
          message: 'Assessment archived',
        });
      })
      .catch((error) => {
        notify({
          type: 'warning',
          message: 'Failed to archive assessment',
        });
      });
  }, [userGroupId, userGroupAssessmentId, updateUserGroupAssessment, notify]);
  const handleRestore = useCallback(() => {
    updateUserGroupAssessment(userGroupId, userGroupAssessmentId, {
      archived_state: null,
    })
      .then(() => {
        notify({
          type: 'success',
          message: 'Assessment restored',
        });
      })
      .catch((error) => {
        notify({
          type: 'warning',
          message: 'Failed to restore assessment',
        });
      });
  }, [userGroupId, userGroupAssessmentId, updateUserGroupAssessment, notify]);

  return (
    <AssessmentReviewDetailRouter
      userGroup={userGroup}
      userGroupAssessment={userGroupAssessment}
      assessment={assessment}
      onArchive={handleArchive}
      onRestore={handleRestore}
    />
  );
}

export default connect(
  (store) => ({
    currentWorkspaceId: store.currentWorkspaceId,
  }),
  {
    updateUserGroupAssessment,
  }
)(CapabilitiesAssessmentReviewDetailEngine);
